import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"camera-1, picture, image, cam"} maskId="square-filled-radius-0-stroke-1-IconCamera1"><path fillRule="evenodd" clipRule="evenodd" d="M7.23241 6L9.23241 3H14.7676L16.7676 6H22V21H2V6H7.23241ZM8.25 12.5C8.25 10.4289 9.92893 8.75 12 8.75C14.0711 8.75 15.75 10.4289 15.75 12.5C15.75 14.5711 14.0711 16.25 12 16.25C9.92893 16.25 8.25 14.5711 8.25 12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCamera1;
